import React from 'react';

import { EmptyIllustration } from '@dashboard/components/empty-states/EmptyIllustration';
import { Card, CardContent } from '@mui/material';

export default function EmptyRequestLog() {
  return (
    <Card
      sx={{
        height: 'calc(100vh - 80px)',
        overflow: 'auto',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      <CardContent>
        <EmptyIllustration caption="Select an API request to see the details." />
      </CardContent>
    </Card>
  );
}
